import { useLayoutEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

const Portal = ({ children }) => {
  const body = useRef(document.querySelector('body'));
  const el = useRef(document.createElement('div'));

  useLayoutEffect(() => {
    body.current.appendChild(el.current);
    return () => {
      body.current.removeChild(el.current);
    };
  }, []);

  return createPortal(children, el.current);
};

export default Portal;



// WEBPACK FOOTER //
// ./src/components/dropdowns/portal/Portal.jsx